import React from 'react';
import styles from './progressTracker.module.css';

const ProgressTracker = ({ currentStepId, nodes, edges, onStepClick }) => {
  const getOrderedNodes = () => {
    if (!nodes?.length) return [];

    const start = nodes.find(
      (node) => !edges.some((edge) => edge.target === node.id)
    );
    if (!start) return [];

    const order = [start];
    const visited = new Set([start.id]);
    let current = start;

    while (current) {
      const nextEdge = edges.find(
        (e) => e.source === current.id && !visited.has(e.target)
      );
      if (!nextEdge) break;
      const nextNode = nodes.find((n) => n.id === nextEdge.target);
      if (!nextNode) break;
      order.push(nextNode);
      visited.add(nextNode.id);
      current = nextNode;
    }

    return order;
  };

  const formatLabel = (label) => {
    let clean = label
      .replace(/Node$/, '')
      .replace(/([A-Z])/g, ' $1')
      .trim();
    switch (clean.toLowerCase()) {
      // case 'choose products':
      //   return 'Choose Services';
      // case 'account signup':
      //   return 'Setup Account';
      default:
        return clean
          .toLowerCase()
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
    }
  };

  const steps = getOrderedNodes();
  const currentIndex = steps.findIndex((n) => n.id === currentStepId);

  return (
    <div className={styles.tracker}>
      {steps.map((node, i) => (
        <React.Fragment key={node.id}>
          <div
            className={`${styles.step} ${i <= currentIndex ? styles.active : ''
              }`}
            onClick={() => {
              if (i <= currentIndex) {
                onStepClick(node.id);
              }
            }}
          >
            <div className={styles.circle}>{i + 1}</div>
            <div className={styles.label}>{formatLabel(node.data.label)}</div>
          </div>
          {/* Show label only if active in mobile */}
          {i < steps.length - 1 && (
            <div
              className={`${styles.line} ${i < currentIndex ? styles.lineActive : ''
                }`}
            />
          )}
        </React.Fragment>
      ))}
      <div className={styles.labelMobile}>
        {steps && steps[currentIndex] ? formatLabel(steps[currentIndex].data.label) : null}
      </div>
    </div>
  );
};

export default ProgressTracker;
